// ============================================
// Subscription Service
// Calls Cloud Functions for subscription management
// ============================================

import { CF_BASE_URL } from '../../config/api';

const BASE_URL = CF_BASE_URL;

export interface SubscriptionItem {
  id: string;
  productName: string;
  amount: number | null;
  currency: string;
  interval: string | undefined;
}

export interface Subscription {
  id: string;
  status: string;
  currentPeriodStart: number;
  currentPeriodEnd: number;
  cancelAtPeriodEnd: boolean;
  canceledAt: number | null;
  items: SubscriptionItem[];
  created: number;
}

export async function getSubscriptions(customerEmail: string): Promise<Subscription[]> {
  const response = await fetch(`${BASE_URL}/getCustomerSubscriptions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ customerEmail }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(err.error || 'Failed to get subscriptions');
  }

  const data = await response.json();
  return data.subscriptions;
}

export async function createPortalSession(customerEmail: string): Promise<string> {
  const response = await fetch(`${BASE_URL}/createCustomerPortalSession`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ customerEmail }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(err.error || 'Failed to create portal session');
  }

  const data = await response.json();
  return data.url;
}
